// React Native
import React from 'react';
import { View, Text, Pressable, StyleSheet, Linking } from 'react-native';
import { useNavigation } from '@react-navigation/native';

 const AdvertisePlaceholder= () => {
  const navigation = useNavigation();

  const handlePress = () => {
    if (navigation?.navigate) {
      navigation.navigate('ProviderAdvertiseForm');
    } else {
      Linking.openURL('mailto:sales@example.com?subject=Advertising%20Inquiry');
    }
  };

  return (
    <View style={styles.container}>
      <Pressable onPress={handlePress} accessibilityRole="link">
        <Text style={styles.linkText}>Contact us to advertise here</Text>
      </Pressable>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    borderWidth: 2,
    borderStyle: 'dashed',
    borderColor: '#9aa4af',
    borderRadius: 12,
    padding: 16,
    minHeight: 120,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#f8fafc',
  },
  linkText: {
    color: '#2563eb',
    textDecorationLine: 'underline',
    fontWeight: '600',
    fontSize: 16,
  },
});
export default AdvertisePlaceholder;
